/**
 * List
 */

import Config from '../Config';
import Util from '../Util';
import Search from './Search';
import Template from './Template';
import Loading from '../Loading';
import DropdownLayer from '../DropdownLayer';
import ParamInfo from './ParamInfo';
import ListCategory from './ListCategory';
import ListSizeChanger from './ListSizeChanger';
import PageNavigation from './PageNavigation';
import ListTopUtil from './ListTopUtil';
import NoticeList from './NoticeList';
import GameInfo from '../GameInfo';
import ArticleDelete from './my/ArticleDelete';
import BookmarkDelete from './my/BookmarkDelete';
import User from '../User';
import Svg from '../Svg';
import ListShare from './ListShare';

class List {
  public onLoaded: any;

  public paramInfo: ParamInfo;

  protected viewMode: string;

  protected listId: string = 'ncCommunityBoardList';

  protected loading: Loading;

  protected isFirstLoaded: boolean = false;

  protected search: Search;

  protected pageNavigation: PageNavigation;

  protected $node: any;

  protected _id: string;

  private listData: any = {};

  private listTopUtil: ListTopUtil;

  private size: number;

  // tag

  private tagSessionName: string = 'search_result_tags';

  private tagLastItemCnt: number = 0;

  private tagArticleIdList: any = [];

  private tagOrder: any;

  private tagOrderType: string = 'postDate';

  // Infinite
  private listShare: ListShare;

  private infiniteSessionName: string = 'COMMUNITY_INFINITE_LIST';

  private searchType: String = '';

  private hasMore: Boolean = true;

  private navigationType: number = 0;

  private moreDirection: string;

  private articleId: string = '0';

  private articleItemCnt: number = 0;

  private articleIdList: any = [];

  private totalCount: number;

  private totalElements: number;

  private lastItemCnt: number = 0;

  private apiUrl: string = '';

  private scrollY: number = 0;

  constructor(node: any, options: any) {
    this.$node = node;
    this.$node.addClass(Config.COMMUNITY_NODE);

    this.navigationType = window.performance.navigation.type;

    this._id = this.$node.attr('id');

    this.isFirstLoaded = false;

    // api data
    this.listData = {};

    this.apiUrl = '';

    jQuery.extend(true, Config, options);

    this.loading = new Loading(this.$node);
    this.loading.setUI();
    this.loading.show();

    // loadedComplete
    this.onLoaded = new Util.Observer();

    // parameter & hash Module - page, query, searchType, articleId
    this.paramInfo = new ParamInfo();
    this.paramInfo.setParamByUrl();

    // get viewMode - get cookie or parameter
    this.viewMode = this.getViewMode();

    // get size - get cookie or parameter
    this.size = this.getSize();

    // menu Module
    const listTopUtil = (this.listTopUtil = new ListTopUtil(this.$node));
    listTopUtil.onViewMode.add((viewMode: any) => {
      const pInfo = this.paramInfo;

      // It's works, If viewMode is card Mode
      if (viewMode === 'card') {
        Util.setCookie(`board_${Config.board}_viewMode`, 'card');
        pInfo.setParam(['viewMode', 'card']);

        // It's works, If viewMode is thumbnail Mode
      } else if (Config.board && Config.isThumbView && !Config.isListView) {
        Util.setCookie(`board_${Config.board}_viewMode`, 'thumb');
        pInfo.setParam(['viewMode', 'thumb']);

        // list mode(default)
      } else {
        Util.setCookie(`board_${Config.board}_viewMode`, 'list');
        pInfo.setParam(['viewMode', 'list']);
      }

      // go to List page with the viewMode
      location.href = Config.listPage + '?' + pInfo.getParam();
    }, this);

    // It's works, If write Button is Clicked
    listTopUtil.onWrite.add((evt: any) => {
      const pInfo = this.paramInfo;
      if (User.isCheckNotExistGameAccount() && GameInfo.isLogined()) {
        Config.alert(Config.L10N.alert_not_exist_gameaccount);
      } else {
        if (Config.onHookWriteBefore()) {
          this.setSessionArticle(evt, () => {
            location.href = Config.writePage + '?' + pInfo.getParamIgnore('query');
          });
        }
      }
    }, this);

    listTopUtil.showButtonType(this.viewMode);

    const $listCountArea = this.listTopUtil.getListSizeNode();

    if (Config.isListCount) {
      const listSizeChanger = new ListSizeChanger($listCountArea, this.size);
      listSizeChanger.onChange.add((value: any) => {
        this.paramInfo.setParam(['size', value]);
        this.paramInfo.setParam(['page', 1]);
        location.href = `${Config.listPage}?${this.paramInfo.getParam().substr(1)}`;
      }, this);
      listSizeChanger.onInit.add((value: any) => {
        // onInit
      }, this);
    } else {
      $listCountArea.hide();
    }

    // pagenavigation Module
    this.pageNavigation = new PageNavigation(this.paramInfo);

    // board search Module
    this.search = new Search($('#wrapSearch'), (query = '', searchType = '') => {
      const pInfo = this.paramInfo;
      let pQuery = query;
      let pSearchType = searchType;

      if (query.indexOf('#') === 0) {
        pQuery = query.substring(1, query.length);
        pSearchType = Config.isTag ? 'hash' : searchType;
      }

      pInfo.setParam(['query', encodeURIComponent(pQuery)]);
      pInfo.setParam(['searchType', pSearchType]);
      pInfo.setParam(['page', 1]);
      pInfo.setParam(['viewMode', pInfo.getParamByKey('viewMode')]);
      pInfo.setParam(['categoryId', pInfo.getParamByKey('categoryId')]);

      location.href = `${Config.listPage}?${pInfo.getParam().substr(1)}`;
    });

    this.search.onResetSearch.add(() => {
      const pInfo = this.paramInfo;
      pInfo.setParam(['page', 1]);
      pInfo.setParam(['viewMode', pInfo.getParamByKey('viewMode')]);
      pInfo.setParam(['categoryId', pInfo.getParamByKey('categoryId')]);

      pInfo.removeParam(['query']);
      pInfo.removeParam(['searchType']);

      location.href = `${Config.listPage}?${pInfo.getParam().substr(1)}`;
    }, this);

    if (Config.isListShare) {
      const listShare = jQuery(Template.listShare());
      this.$node.append(listShare);
      this.listShare = new ListShare(listShare, Config.share);
    }

    if (Config.isArticleDelete) {
      const articleDelete = new ArticleDelete(Config.guid);
    }

    if (Config.isBookmarkDelete) {
      const bookmarkDelete = new BookmarkDelete();
    }

    this.addEvent();
    this.addObserver();
  }

  public getData() {
    return this.listData;
  }

  public get(url?: string) {
    Svg.get();

    if (url) {
      this.apiUrl = url;
    }

    if (Config.isCategory || Config.isShowCategory || Config.isShowCategory2Depth) {
      const _defaultCategory = Util.getParams().categoryId;

      const listCategory = new ListCategory(this.listTopUtil.getNode(), _defaultCategory || '', true, true);
      listCategory.onChange.add((data: any) => {
        const pInfo = this.paramInfo;
        pInfo.setParam(['categoryId', data]);
        pInfo.setParam(['page', 1]);
        pInfo.removeParam(['query']);
        pInfo.removeParam(['searchType']);
        location.href = Config.listPage + '?' + pInfo.getParam();
        // if (pInfo.getParamByKey('searchType') === 'hash' && pInfo.getParamByKey('query') !== '') {
        //   location.href = Config.listPage + '?' + pInfo.getParam();
        // } else {
        //   location.href = Config.listPage + '?' + pInfo.getParamIgnore('query');
        // }
      });
      listCategory.onInit.add((categoryId: any) => {
        const pInfo = this.paramInfo;
        pInfo.setParam(['categoryId', categoryId]);
        this.getTopNotice(categoryId);
        this.getList(categoryId);
      });
      listCategory.onNull.add(() => {
        this.getList();
      });
    } else {
      this.getTopNotice();
      this.getList();
    }
  }

  private getList(categoryId?: any) {
    const paramData = this.setArticleParam(categoryId);
    let listAPIUrl = '';

    if (Config.isInfinite) {
      if (Config.board === 'all') {
        listAPIUrl = Config.listMoreAll(Config.board);
      } else {
        listAPIUrl = Config.listMore(Config.board);
      }
    } else {
      if (Config.board === 'all') {
        listAPIUrl = Config.allList(Config.board);
      } else {
        listAPIUrl = Config.list(Config.board);
      }
    }

    if (this.apiUrl !== '') {
      listAPIUrl = this.apiUrl;
    }

    if (Config.isTag && paramData.searchType === 'hash') {
      this.getTagList();
      return;
    }

    if (!this.isFirstLoaded && Config.isInfinite && this.navigationType === 2) {
      this.getSessionArticle();
      return;
    }

    const listPromise: any = Util.get(listAPIUrl, 'GET', paramData);
    const get$ = Util.from(listPromise);
    get$.subscribe(
      (data: any) => {
        const pInfo = this.paramInfo;
        let emptyUI = '';
        let listUI: any;
        let searchUI: string;
        let pageUI: string;

        if (!data) {
          return;
        }

        // if(Config.isUuid) {
        //   // my API
        //   if (data.listMoreUserArticleEntries && data.listMoreUserArticleEntries.userArticleList) {
        //     data.articleList = data.listMoreUserArticleEntries.userArticleList;
        //   }
        // } else {
        //
        // }

        if (data.listArticleEntries) {
          data.pageNavigation = data.listArticleEntries.pageNavigation;
          data.articleList = data.listArticleEntries.articleList;
        }

        // my API
        if (data.userArticleList) {
          data.articleList = data.userArticleList;
        }

        // bookmark have not articleList.
        if (data.scrapList) {
          data.articleList = data.scrapList;
        }

        if (data.articleList === null) {
          this.loading.hide();
          this.onLoaded.emit();
          if (Config.isInfinite) {
            jQuery('.nc-comment-more').hide();
          }
          return;
        }

        // set data to search Module
        this.search.setQuery(decodeURIComponent(pInfo.getParamByKey('query')));
        this.search.setSearchType(pInfo.getParamByKey('searchType'));
        this.hasMore = data && data.hasMore ? data.hasMore : false;
        searchUI = this.setSearchUI(data);
        pageUI = this.setPageUI(data);

        if (Config.isInfinite) {
          this.loading.showBottom();
        } else {
          this.remove();
        }

        // isFirstLoaded empty data
        if (data.articleList.length === 0 && !this.isFirstLoaded) {
          emptyUI = this.setEmptyUI();
          if (this.search.getQuery() && this.search.getSearchType()) {
            pInfo.removeParam(['query']);
            pInfo.removeParam(['searchType']);
            emptyUI = Util.Tmpl.join(searchUI + emptyUI);
          }
          this.$node.append(emptyUI);
          this.loading.hide();
          this.onLoaded.emit();

          return;
        }

        listUI = this.setListUI(data);

        if (!this.isFirstLoaded) {
          this.totalCount = data.totalCount ? data.totalCount : 0;
          this.$node.append(searchUI + listUI.tmpContainer);
        }

        // append template data
        const $appendNode = jQuery(`#${this._id} .${this.listId}`);
        $appendNode.append(listUI.tmpArticleList);

        if (!this.isFirstLoaded) {
          $appendNode.after(pageUI);
        }

        if (Config.isInfinite) {
          if (!this.hasMore) {
            jQuery('.nc-comment-more').hide();
          }
        }

        this.listData = data;

        // first loaded?
        this.isFirstLoaded = true;

        this.loading.hide();
        this.onLoaded.emit();
      },
      () => {
        this.loading.hide();
        this.onLoaded.emit();
      }
    );
  }

  public setArticleParam(categoryId?: any) {
    const _param = Util.getParams();
    const pInfo = this.paramInfo;
    let page;

    page = _param.page || 1;
    page = pInfo.removeVag(page);
    page = parseInt(page, 10);

    pInfo.setParamByUrl();
    pInfo.setParam(['viewMode', this.viewMode || '']);
    pInfo.setParam(['size', this.size]);

    let pQuery = decodeURIComponent(pInfo.getParamByKey('query'));
    let pSearchType = pInfo.getParamByKey('searchType');
    const pCategoryId = pInfo.getParamByKey('categoryId') || categoryId || '';
    const pSummary = pInfo.getParamByKey('viewMode') === 'card' ? true : false;
    const pSite = ((window as any).userData && (window as any).userData.site) || '';
    const pRefererSite = ['lineagem', 'lineage'];
    const isReferer = pQuery && pSearchType && pRefererSite.indexOf(pSite) !== -1 ? true : false;
    const isVote = Config.isVote ? 'true' : 'false';
    const pMetaTags = pInfo.getParamByKey('metaTags');

    return Config.isInfinite
      ? {
          query: pQuery,
          searchType: pSearchType,
          summary: pSummary,
          isVote,
          moreSize: this.size,
          previousArticleId: this.articleId,
          moreDirection: this.moreDirection,
          categoryId: pCategoryId,
          guid: Config.userGuid || '',
          gameUserUid: Config.gameUserUid || '',
          gameCharacterId: Config.gameCharacterId || '',
          gameServerId: Config.gameServerId || '',
          serverType: Config.serverType || '',
          metaTags: pMetaTags,
        }
      : {
          query: pQuery,
          searchType: pSearchType,
          summary: pSummary,
          size: pInfo.getParamByKey('size'),
          page,
          isReferer,
          isVote,
          categoryId: pCategoryId,
          guid: Config.userGuid || '',
          gameUserUid: Config.gameUserUid || '',
          gameCharacterId: Config.gameCharacterId || '',
          gameServerId: Config.gameServerId || '',
          serverType: Config.serverType || '',
          metaTags: pMetaTags,
        };
  }

  public setEmptyUI() {
    const pInfo = this.paramInfo;
    let tmpEmpty;

    if (this.search.getQuery() && this.search.getSearchType()) {
      pInfo.removeParam(['query']);
      pInfo.removeParam(['searchType']);
      tmpEmpty = Template.emptySearch(this.listId, Config.L10N.search_none, `${pInfo.getParam().substr(1)}`);
    } else {
      tmpEmpty = Template.empty(this.listId, Config.L10N.list_none_article);
    }

    return tmpEmpty;
  }

  public setListUI(data: any) {
    const pInfo = this.paramInfo;

    let tmpContainer: string = '';
    let tmpArticleList: string = '';
    if (pInfo.getParamByKey('query') && pInfo.getParamByKey('searchType') !== 'tag') {
      tmpContainer = Template.listContainer(this.listId, 'search');
      tmpArticleList = Template.searchList(data, this.listId, pInfo.getParamIgnore('isNotice'));
    } else if (this.viewMode === 'card' && Config.isCardView) {
      tmpContainer = Template.listContainer(this.listId, 'card');
      tmpArticleList = Template.cardList(data, this.listId, pInfo.getParamIgnore('isNotice'));
    } else if (this.viewMode === 'thumb' && Config.isThumbView) {
      tmpContainer = Template.listContainer(this.listId, 'thumb');
      tmpArticleList = Template.thumbList(data, this.listId, pInfo.getParamIgnore('isNotice'));
    } else {
      tmpContainer = Template.listContainer(this.listId, 'default');
      tmpArticleList = Template.list(data, this.listId, pInfo.getParamIgnore('isNotice'));
    }

    return { tmpContainer, tmpArticleList };
  }

  public setSearchUI(data: any) {
    const pInfo = this.paramInfo;
    const totalCount = Config.isInfinite ? data.totalCount || 0 : data.pageNavigation.totalCount || 0;

    let searchUI = '';

    this.search.setQuery(decodeURIComponent(pInfo.getParamByKey('query')));
    this.search.setSearchType(pInfo.getParamByKey('searchType'));

    if (Config.isShowSearchResult) {
      searchUI = this.search.setResultUI(totalCount);
    }

    return searchUI;
  }

  public setPageUI(data: any) {
    let pageUI;

    if (Config.isInfinite) {
      const tempMore = Template.btnCommentMore();
      const tempTop = Template.btnListTop();
      pageUI = Util.Tmpl.join(tempMore, tempTop);
    } else {
      pageUI = this.pageNavigation.setUI(data.pageNavigation);
    }

    return pageUI;
  }

  public remove() {
    jQuery(`#${this._id} .${this.listId}`).empty();

    if (Config.isInfinite) {
      jQuery(`#${this._id} .nc-comment-more`).remove();
    } else {
      jQuery(`#${this._id} .pagination-container`).remove();
    }
  }

  private goToViewShungShung(evt: any) {
    evt.preventDefault();
    evt.stopPropagation();
    const $this = jQuery(evt.currentTarget);
    const _link = $this.find('a').attr('href');
    if (!!_link) {
      !Config.isListLinkTargetBlank ? (location.href = _link) : window.open(_link, '_blank');
    }
  }

  private addEvent() {
    jQuery('body').on(
      'click',
      'li.board-items .title, li.board-items .thumb, li.board-items .board-items-thumb, li.board-items .desc, li.board-items .writer, li.board-items > .comment',
      (evt: any) => {
        evt.preventDefault();
        if (Config.isInfinite) {
          this.setSessionArticle(evt, () => this.goToViewShungShung(evt));
        } else {
          this.goToViewShungShung(evt);
        }
      }
    );

    if (Config.isInfinite) {
      jQuery('body').on('click', `#${this._id} .nc-comment-more`, (evt: any) => {
        evt.preventDefault();
        // this.articleId = jQuery(`#${this._id} .board-items:last`).attr('data-articleid');
        this.articleId = document.querySelector(`#${this._id} .board-items:last-child`).getAttribute('data-articleid');
        this.moreDirection = 'BEFORE';
        this.scrollY = window.scrollY || window.pageYOffset;
        this.getList();
      });

      jQuery('body').on('click', '.board-notice-item', (evt: any) => {
        evt.preventDefault();
        this.setSessionArticle(evt, () => this.goToViewShungShung(evt));
      });

      jQuery( 'body' ).on( 'click', '.co-btn-top_list', ( evt ) => {
        evt.preventDefault();
        jQuery( window ).scrollTop( 0 );
      });
    }
  }

  private addObserver() {
    this.onLoaded.add(()=>{
      window.scrollTo(0, Number(this.scrollY));
    })
  }

  private getTopNotice(categoryId = '') {
    if (Config.isTopNotice) {
      const noticeList = new NoticeList(this.$node, categoryId);
      noticeList.get();
    }
  }

  // get current viewMode
  private getViewMode() {
    const pInfo = this.paramInfo;
    let viewMode = Config.isCardView && Config.isListView ? 'list' : 'card';
    viewMode = Config.isDefaultViewMode === 'card' ? 'card' : Config.isThumbView && Config.isDefaultViewMode === 'thumb' ? 'thumb' : 'list';

    const _cookie = `board_${Config.board}_viewMode`;
    viewMode = pInfo.getParamByKey('viewMode') || Util.getCookie(_cookie) || viewMode;
    return viewMode;
  }

  public getSize() {
    const pInfo = this.paramInfo;
    const _cookie = `board_list_count`;

    // TODO removeCookie - 17.6.12
    // let listSize = pInfo.getParamByKey( 'size' ) || Util.getCookie( _cookie ) || Config.listSize;
    let listSize = pInfo.getParamByKey('size') || Config.listSize;
    listSize = parseInt(listSize, 10);
    listSize = listSize > 100 ? 100 : listSize;
    Util.setCookie(_cookie, listSize, '/');
    return listSize;
  }

  /*
   * Infinite List
   */
  private setSessionArticle(evt: any, callback?: any) {
    const $items = jQuery(`.${this.listId} li`);
    const _markup = jQuery(`.${this.listId}`).html();
    const _arr: any = [];
    const pInfo = this.paramInfo;

    $items.map((idx, value) => {
      _arr.push($(value).data('articleid'));
    });

    const _data = {
      board: Config.board,
      articleId: _arr,
      hasMore: this.hasMore,
      lastItemCnt: this.lastItemCnt,
      markup: _markup,
      scrollY: window.scrollY,
      viewMode: this.viewMode,
      searchType: pInfo.getParamByKey('searchType'),
      totalCount: this.totalCount,
    };

    sessionStorage.setItem(this.infiniteSessionName, JSON.stringify(_data));

    if (callback) {
      callback(evt);
    }
  }

  private getSessionArticle() {
    let _data = JSON.parse(sessionStorage.getItem(this.infiniteSessionName));
    let tmpContainer;

    if (!_data || _data.board !== Config.board ) {
      location.reload();
      return;
    }

    this.isFirstLoaded = true;
    this.articleItemCnt = _data.lastItemCnt;
    this.articleIdList = _data.articleId;
    this.totalCount = _data.totalCount;
    this.viewMode = _data.viewMode === 'list' ? 'default' : _data.viewMode;
    this.hasMore = _data.hasMore;
    this.searchType = _data.searchType;

    let searchUI = this.setSearchUI(_data);

    if (this.articleIdList[0] === null) {
      tmpContainer = Template.listContainer(this.listId, 'none');
    } else if (this.searchType === '') {
      tmpContainer = Template.listContainer(this.listId, this.viewMode);
    } else {
      tmpContainer = Template.listContainer(this.listId, 'search');
      tmpContainer = searchUI + tmpContainer
    }

    this.$node
      .append(tmpContainer)
      .promise()
      .done(() => {
        jQuery(`.${this.listId}`).append(_data.markup);
        this.setMoreButton( !!(this.hasMore) );
        if (this.searchType !== '') {
          this.search.addSearchEvent();
        }
        window.scrollTo(0, Number(_data.scrollY));
        this.loading.hide();
        sessionStorage.removeItem(this.infiniteSessionName);
      });
  }

  private setMoreButton(hasMore: boolean) {
    const $appendNode = jQuery(`#${this._id} .${this.listId}`);
    const tempMore = (hasMore) ? Template.btnCommentMore() : '';
    const tempTop = Template.btnListTop();
    const _tmp = Util.Tmpl.join(tempMore, tempTop);

    $appendNode.after(_tmp);
  }

  /*
   * Search result for Tags
   */
  private getTagList() {
    this.setTagUI();

    switch (this.navigationType) {
      // TYPE_NAVIGATENEXT
      case 0:
        this.getTagListItems();
        this.addTagEvents();
        break;

      // TYPE_RELOAD
      case 1:
        this.getTagListItems();
        this.addTagEvents();
        break;

      // TYPE_BACK_FORWARD
      case 2:
        this.getSessionTagList();
        this.addTagEvents();
        break;

      // TYPE_UNDEIFINED
      default:
        break;
    }
  }

  private setTagUI() {
    // set data to search Module
    const pInfo = this.paramInfo;
    this.search.setQuery(decodeURIComponent(pInfo.getParamByKey('query')));
    this.search.setSearchType(pInfo.getParamByKey('searchType'));
    const pQuery = decodeURIComponent(pInfo.getParamByKey('query'));
    // const tempSearch = this.setTagSearchUI();
    const tempCount = this.setTagTotalCount();
    const tempContainer = this.setTagContainer();
    const tempMore = Template.btnCommentMore('nc-comment-more_tag');
    const tempTop = Template.btnListTop();
    const _tmp = Util.Tmpl.join(tempCount, tempContainer, tempMore, tempTop);

    this.$node.append(_tmp);
    this.setTagOrder();
    // Todo. 연관검색 기능 추가 개발 진행 시 검색 input UI변경 예정
    $('.board-search-result_tag').text(pQuery);
    $('#ncCommunitySearchType .ui-dropdown').addClass('is-tag');
  }

  private setTagTotalCount() {
    const tagResult = `<div class="board-search-result_tag"></div>`;
    const template = this.search.setResultUI('0');
    return tagResult + template;
  }

  private setTagContainer() {
    return Template.searchListTagContainer(this.listId);
  }

  private setTagOrder() {
    let $selector = jQuery('.board-search-result');
    let orderTypeList = [
      {
        key: 'postDate',
        value: '최신순'
      },
      {
        key: 'goodCount',
        value: '추천순'
      },
      {
        key: 'commentCount',
        value: '댓글순'
      }
    ];
    this.tagOrder = new DropdownLayer($selector, orderTypeList, 'tagOrder', 'tag-order');
    this.tagOrder.addChange((data = '') => {
      this.tagOrderType = data;
      this.clearTagListItem();
      this.getTagListItems(0);
    });

    this.updateTagOrder();
  }

  private updateTagOrder() {
    let defaultOrder = this.tagOrderType ? this.tagOrderType : 'postDate';
    this.tagOrder.setValue(defaultOrder);
  }

  private clearTagListItem() {
    jQuery(`.${this.listId}`).empty();
    this.tagArticleIdList = [];
    sessionStorage.removeItem(this.tagSessionName);
  }

  private getTagListItems(_lastItemCnt?: number) {
    const pInfo = this.paramInfo;
    const pQuery = decodeURIComponent(pInfo.getParamByKey('query'));
    const _tagContent = Config.board.indexOf('guild') === -1 ? Config.tagContent : Config.tagContentGuild;
    let requestParams = {
      filter1: Config.board === 'all' ? '' : Config.board,
      query: pQuery,
      lastItemCnt: _lastItemCnt ? _lastItemCnt : 0,
      page_size: this.size,
      direction: 'desc',
      orderBy: this.tagOrderType
    };

    const hashPromise: any = Util.get(_tagContent, 'GET', requestParams);
    const getTag$ = Util.from(hashPromise);

    getTag$.subscribe(
      (data: any) => {
        if (!data) {
          return;
        }
        const pInfo = this.paramInfo;
        let tmp = '';
        let _contents: any = [];

        // data = Util.convertCamelCase( data );

        // empty data
        if (data.contents.length === 0) {
          jQuery(`#${this._id} .nc-comment-more_tag`).hide();

          if (!this.isFirstLoaded) {
            jQuery('#tagOrder').find('.select').addClass('disabled');
            jQuery('#tagOrder').find('select').prop('disabled', true);
            pInfo.removeParam(['query']);
            pInfo.removeParam(['searchType']);
            tmp = Template.emptySearchTag(this.listId, Config.L10N.search_none, `${pInfo.getParam().substr(1)}`);
            jQuery(`.${this.listId}`).append(tmp);
            this.loading.hide();
            this.onLoaded.emit();
            return;
          }
        }

        // 중복 데이터 체크
        if (this.tagArticleIdList.length !== 0) {
          data.contents.forEach((v: any) => {
            if (this.tagArticleIdList.indexOf(Number(v.articleId)) === -1) {
              _contents.push(v);
            }
          });
        } else {
          _contents = data.contents;
        }

        tmp = Template.searchListTagItems(_contents, pInfo.getParamIgnore('isNotice'));
        this.listData = data;
        this.tagLastItemCnt = data.lastItemCnt;
        this.totalElements = data.totalElements;

        // append template data
        jQuery(`.${this.listId}`).append(tmp);

        if (!this.isFirstLoaded) {
          this.updateTagCount(data.totalElements);
          this.isFirstLoaded = true;
        }

        this.loading.hide();
        this.onLoaded.emit();
      },
      () => {
        this.loading.hide();
        this.onLoaded.emit();
      }
    );
  }

  private getSessionTagList() {
    let _data = JSON.parse(sessionStorage.getItem(this.tagSessionName));

    // Todo 데이터 없는 케이스 추가
    if (!_data) {
      return;
    }

    this.isFirstLoaded = true;
    this.tagOrderType = _data.orderBy;
    this.tagLastItemCnt = _data.lastItemCnt;
    this.tagArticleIdList = _data.articleId;
    this.updateTagCount(_data.totalElements);
    this.totalElements = _data.totalElements
    this.updateTagOrder();
    jQuery(`.${this.listId}`).append(_data.markup);
    window.scrollTo(0, Number(_data.scrollY));
    this.search.addSearchEvent();

    this.loading.hide();
    this.onLoaded.emit();
  }

  private addTagEvents() {
    jQuery('body').on('click', '.board-list-search .board-items a', (evt: any) => {
      evt.preventDefault();
      const $target = jQuery(evt.target);
      const $items = jQuery(`.${this.listId} li`);
      const _link = $target.attr('href');
      const _markup = jQuery(`.${this.listId}`).html();
      const _arr: any = [];
      $items.map((idx, value) => {
        _arr.push($(value).data('articleid'));
      });

      const _data = {
        articleId: _arr,
        scrollY: window.scrollY,
        markup: _markup,
        lastItemCnt: this.tagLastItemCnt,
        orderBy: this.tagOrderType,
        totalElements: this.totalElements
      };

      sessionStorage.setItem(this.tagSessionName, JSON.stringify(_data));
      location.href = _link;
    });

    jQuery('body').on('click', `#${this._id} .nc-comment-more_tag`, (evt: any) => {
      this.scrollY = window.scrollY || window.pageYOffset;
      const _data = this.getData();
      const _count = this.tagLastItemCnt !== 0 ? this.tagLastItemCnt : _data.lastItemCnt;
      const _size = this.getSize();
      let sum = Number(_count + _size);
      this.tagLastItemCnt = sum;
      this.getTagListItems(sum);
    });
  }

  private updateTagCount(count: any) {
    jQuery('.board-search-result .count').html(`${count}${Config.L10N.search_result_count}`);
  }
}

export default List;
